import React from "react"
import { connect } from "react-redux"
import OpenOrdersListModal from "../../components/shop/open-orders-list-modal"

const mapStateToProps = state => {
  const items = state.entities.openOrders
  return {
    currentShop: state.currentShop.entity,
    isOpen: state.currentShop.openOrders.isListModalOpen,
    items,
    products: state.entities.products,
    sortedItemIds: [...items.allIds].sort((id1,id2) => items[id1].createdAt > items[id2].createdAt ? 1 : -1)
  }
}

const mapDispatchToProps = dispatch => ({
  onClickDelete: () => dispatch({type: 'OPEN_ORDER.DELETE_ALL'}),
  onClickItem: id => dispatch({type: "OPEN_ORDER.ITEM_CLICKED", payload: {id}}),
  onRequestClose: () => dispatch({type: "OPEN_ORDER.CLOSE_LIST"})
})

export default connect(mapStateToProps, mapDispatchToProps)(OpenOrdersListModal)
